export default "__VITE_ASSET__510a2cda__"